import {Box, Typography} from '@mui/material';
import React, {useCallback} from 'react';
import {useDrag} from 'react-dnd';
import AurIcon, {IconColors, IconNames} from '../aur-icon/AurIcon';

interface IAurDraggableItem {
  field: {name: string; label: string};
  docsHit?: string;
  lastRunDate?: string;
  isDraggable?: boolean;
  type: string;
  onPressEnterFromDragIcon?: (type: string) => void;
}

const AurDraggableItem: React.FC<IAurDraggableItem> = ({
  field,
  type,
  onPressEnterFromDragIcon,
}) => {
  const [{isDragging}, drag] = useDrag(() => ({
    type: type,
    item: {field, type},
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
  }));

  const onKeyDown = useCallback(
    (e: React.KeyboardEvent<HTMLButtonElement>) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        onPressEnterFromDragIcon?.(type);
      }
    },
    [onPressEnterFromDragIcon, type]
  );

  return (
    <Box
      ref={drag}
      sx={{
        cursor: 'grab',
      }}
      className={`draggable-item ${isDragging ? 'dragging' : ''}`}
    >
      <Box
        aria-label={field.label}
        component={'button'}
        className={`draggable-icon-container`}
        onKeyDown={onKeyDown}
      >
        <AurIcon
          size={'medium'}
          icon={IconNames.DragIndicator}
          color={IconColors.Custom}
          customClassName={`draggable-icon`}
        />
      </Box>
      <Box className={'draggable-item-text'}>
        <Typography className={'typo-text subhead4_size'}>
          {field.label}
        </Typography>
      </Box>
    </Box>
  );
};

export default AurDraggableItem;
